import React from "react";
import _ from "lodash";
import Box from "@amzn/meridian/box";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import { formatNumber } from "../../../utils/formattingUtils";

interface TableData {
    label: string;
    key: string;
    editable: boolean;
}

interface ConfigurableTableProps {
    tableData: TableData[];
    headerColumnWidth?: number;
    showDividers?: boolean;
    data: { [key: string]: any } | any[];
    isEditing: boolean;
    handleInputChange: any;
}

export const tableDataValues: TableData[] = [
    {
        label: "Cost Approach",
        key: "appealDetails.appealApproachCalculationData.summary.indicatedValueSummary.costApproach",
        editable: false,
    },
    {
        label: "Income Approach",
        key: "appealDetails.appealApproachCalculationData.summary.indicatedValueSummary.incomeApproach",
        editable: false,
    },
    {
        label: "Sales Approach",
        key: "appealDetails.appealApproachCalculationData.summary.indicatedValueSummary.salesApproach",
        editable: false,
    },
    {
        label: "Indicated Value",
        key: "appealDetails.appealApproachCalculationData.summary.indicatedValueSummary.indicatedValue",
        editable: false,
    },
];

export const IndicatedValueSummary2: React.FC<ConfigurableTableProps> = ({
    tableData = tableDataValues,
    headerColumnWidth = 250,
    showDividers = true,
    data,
    isEditing,
    handleInputChange,
}) => {
    const renderTableCell = (item: TableData, index: number) => {
        const value = Array.isArray(data)
            ? data[index]?.value
            : formatNumber(_.get(data, item.key, ""));

        if (isEditing && item.editable) {
            return (
                <Input
                    value={value}
                    onChange={newValue => handleInputChange(item.key, newValue)}
                    prefix="$"
                />
            );
        }

        return <Text>{`$ ${value}`}</Text>;
    };

    return (
        <Box type="fill" width="40%" spacingInset="400">
            <Table showDividers={showDividers} headerColumns={1} spacing="small">
                {tableData.map((item, index) => (
                    <TableRow key={item.key} highlightOnHover={false}>
                        <TableCell width={headerColumnWidth} backgroundColor="secondary">
                            <Text type="h100">{item.label}</Text>
                        </TableCell>
                        <TableCell>{renderTableCell(item, index)}</TableCell>
                    </TableRow>
                ))}
            </Table>
        </Box>
    );
};
